import { ComponentPropsWithoutRef } from 'react';

import { easeIn, motion } from 'framer-motion';

/**
 * TransitionWrapper Animation
 */
const anim = {
    open: {
        width: '100%',
        transition: { duration: 0.3, ease: easeIn },
        overflow: 'visible'
    },
    closed: {
        width: '0%',
        overflow: 'hidden',
        transition: { duration: 0.2, ease: easeIn }
    }
};

type TransitionWrapperProps = ComponentPropsWithoutRef<'span'> & { isOpen: boolean };

export function TransitionWrapper({ children, isOpen, className }: TransitionWrapperProps) {
    return (
        <motion.span
            initial={false}
            variants={anim}
            className={className}
            animate={isOpen ? 'open' : 'closed'}>
            {children}
        </motion.span>
    );
}
